import { useSelector } from "react-redux";

export const useLoggedUser = () => {
  const userState = useSelector((state) => state.auth?.user);

  return userState || {};
};
